import { Data } from '../Data';

export class PayrollDataService {
    constructor() {
        this.dataService = new Data();
    }

    getW2Info(districtno) {
        const ssnid = this.dataService.getSsnId();
        const url = '/api/payrolldocuments/w2Info?ssnid=' + ssnid + '&districtno=' + districtno;
        return this.dataService.performAuthenticatedFetch(url);
    }

    getPayrollInfo(districtno) {
        const ssnid = this.dataService.getSsnId();
        const url = '/api/payrolldocuments/payrollInfo?ssnid=' + ssnid + '&districtno=' + districtno;
        return this.dataService.performAuthenticatedFetch(url);
    }

    getMiscDocumentInfo(districtno) {
        const ssnid = this.dataService.getSsnId();
        const url = '/api/miscdocuments/info?ssnid=' + ssnid + '&districtno=' + districtno;
        return this.dataService.performAuthenticatedFetch(url);
    }

    getPaystub(districtno, datepaid) {
        const ssnid = this.dataService.getSsnId();
        const url = '/api/payrolldocuments/paystub?ssnid=' + ssnid + '&districtno=' + districtno + '&datepaid=' + datepaid;
        return this.dataService.performAuthenticatedDownload(url);
    }

    getW2(id)
    {
        const url = 'api/payrolldocuments/w2/' + id;
        return this.dataService.performAuthenticatedDownload(url);
    }

    getW2C(id)
    {
        const url = 'api/payrolldocuments/w2c/' + id;
        return this.dataService.performAuthenticatedDownload(url);
    }

    getMiscDocument(documentid)
    {
        const url = '/api/miscdocuments/binary?documentid=' + documentid;
        return this.dataService.performAuthenticatedDownload(url);
    }
}